import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "welcome-step" }
const _hoisted_2 = { class: "welcome-step__header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "h1 color-white" }

import BaseButton from "@/components/base/BaseButton.vue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeStep',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

const goToIdAbonent = (link: string) => {
  window.open(link, "_blank");
};

const isDesktop = ref<boolean>(true);
const adaptiveLink = ref<string>("");

const configDataDefaultBrand = computed(
  () => store.getters["brand/configDataDefaultBrand"]
);

const systemCheck = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    isDesktop.value = false;
    return "https://itunes.apple.com/ru/app/id1368190117?mt=8";
  }

  // Check for Android
  if (/android/i.test(userAgent)) {
    isDesktop.value = false;
    return "https://play.google.com/store/apps/details?id=ru.world.idabonent";
  }

  // Default to desktop
  isDesktop.value = true;
  return "";
};

onMounted(() => {
  adaptiveLink.value = systemCheck();
  console.log(adaptiveLink.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "main-header__logo",
        src: configDataDefaultBrand.value.assets.logo,
        alt: "Логотип"
      }, null, 8, _hoisted_3),
      _createElementVNode("h1", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(t)("auth.welcome.titleLine1")), 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)("auth.welcome.titleLine2")), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "color-secondary caption-small--bold welcome-step__btn-auth",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('login')))
      }, _toDisplayString(_unref(t)("auth.welcome.login")), 1),
      (!isDesktop.value)
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 0,
            title: _unref(t)('auth.welcome.activateSim'),
            size: "large",
            color: "transparent-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToIdAbonent(adaptiveLink.value)))
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})